/* Kaskadierendes Flyout-Menue (header-cascade-menu.liquid).

   Baut auf nativen <details>/<summary> auf: ohne dieses Skript funktioniert
   das Menue bereits per Klick und Tastatur. Ergaenzt werden hier nur

     - Hover-Oeffnen mit Verzoegerung (Hover-Intent), damit das Panel nicht
       bei jedem Mausdurchflug aufklappt,
     - Pfeiltasten-Navigation zwischen den Ebenen,
     - Umklappen eines Panels, wenn rechts kein Platz mehr ist.

   Die Ebenentiefe ist offen: das Markup entsteht rekursiv
   (header-cascade-menu-item.liquid), deshalb sprechen die Selektoren hier
   nicht mehr von "Ebene 2", sondern von "Panel ausser dem ersten" (SUB_PANEL).

   Zentrale Invariante: hoechstens EIN Top-Level-Panel ist offen. Gehalten
   wird sie von activeRoot plus dem toggle-Listener am Ende - egal ob per
   Hover, Klick oder Tastatur geoeffnet wurde.

   Alles per Event-Delegation am document -> ueberlebt das Neu-Rendern der
   Section im Theme-Editor ohne Re-Init. Guard gegen Doppel-Init. */
(function () {
  if (window.__avbCascadeMenuInit) return;
  window.__avbCascadeMenuInit = true;

  var OPEN_DELAY = 120;
  var CLOSE_DELAY = 220;

  /* Das <header-menu>, dessen Panel gerade offen ist (oder null). Einzige
     Quelle der Wahrheit - Timer haengen immer an einem konkreten Root, nie
     global, sonst raeumt ein Item den Timer eines anderen ab. */
  var activeRoot = null;
  var openTimer = null;
  var openTarget = null;
  var closeTimer = null;
  var closeTarget = null;

  /* Hover-Logik nur dort, wo das Inline-Menue sichtbar ist (ab 990px, siehe
     base.css) und wo es echtes Hover gibt - auf Touch bleibt es beim Tippen. */
  function hoverEnabled() {
    return window.matchMedia('(min-width: 990px)').matches && window.matchMedia('(hover: hover)').matches;
  }

  function detailsOf(root) {
    return root ? root.querySelector(':scope > details.cascade-menu') : null;
  }

  /* Die Gruppe zu einem beliebigen Element darin. Ueber das <li> gesucht und
     nicht per closest('details'), weil bei Gruppen mit eigenem Linkziel der
     Textlink neben dem <details> steht und nicht darin. */
  function groupOf(target) {
    var item = target.closest ? target.closest('.cascade-menu__item') : null;
    return item ? item.querySelector(':scope > details.cascade-menu__group') : null;
  }

  function triggerOf(group) {
    return group ? group.querySelector(':scope > summary') : null;
  }

  function setOpen(details, open) {
    if (!details || details.open === open) return;
    details.open = open;
    var summary = details.querySelector(':scope > summary');
    if (summary) summary.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (!open) closeGroupsIn(details);
  }

  function closeGroupsIn(root) {
    root.querySelectorAll('details.cascade-menu__group[open]').forEach(function (group) {
      group.open = false;
      var summary = group.querySelector(':scope > summary');
      if (summary) summary.setAttribute('aria-expanded', 'false');
    });
  }

  function cancelOpen() {
    if (openTimer) clearTimeout(openTimer);
    openTimer = null;
    openTarget = null;
  }

  function cancelClose() {
    if (closeTimer) clearTimeout(closeTimer);
    closeTimer = null;
    closeTarget = null;
  }

  /* Schliesst jedes offene Top-Level-Panel ausser dem uebergebenen - sofort,
     ohne auf dessen eigenen Close-Delay zu warten. Genau hier lag der Bug:
     beim Wechsel zwischen zwei Top-Level-Items blieb das alte Panel offen. */
  function closeOthers(keep) {
    document.querySelectorAll('header-menu > details.cascade-menu[open]').forEach(function (details) {
      if (details.parentElement !== keep) setOpen(details, false);
    });
    if (activeRoot && activeRoot !== keep) activeRoot = null;
  }

  function openRoot(root) {
    var details = detailsOf(root);
    if (!details) return;
    closeOthers(root);
    setOpen(details, true);
    activeRoot = root;
  }

  function closeRoot(root) {
    var details = detailsOf(root);
    if (details) setOpen(details, false);
    if (activeRoot === root) activeRoot = null;
  }

  /* Jedes Panel ausser dem ersten, unabhaengig von der Ebene. Seit die Kaskade
     rekursiv rendert, gibt es nicht mehr nur --level-2. */
  var SUB_PANEL = '.cascade-menu__panel:not(.cascade-menu__panel--level-1)';

  /* Panel wuerde rechts aus dem Viewport laufen -> nach links klappen. Bei drei
     Panels nebeneinander kippt meist erst das dritte, deshalb pro Panel
     gerechnet. Zweiter Schritt: passt die geklappte Variante links auch nicht
     (schmaler Desktop), bleibt es beim Original - lieber rechts anliegend als
     links abgeschnitten, wo der Anfang des Textes verloren waere. */
  function positionPanel(group) {
    var panel = group.querySelector(':scope > ' + SUB_PANEL);
    if (!panel) return;
    panel.classList.remove('cascade-menu__panel--flip');
    var rect = panel.getBoundingClientRect();
    if (rect.right > document.documentElement.clientWidth - 8) {
      panel.classList.add('cascade-menu__panel--flip');
      if (panel.getBoundingClientRect().left < 8) {
        panel.classList.remove('cascade-menu__panel--flip');
      }
    }
  }

  function openGroup(group) {
    /* Geschwister schliessen, damit pro Panel nur eine Gruppe offen ist.
       ':scope > li >' ist hier wesentlich: ohne die Einschraenkung wuerde eine
       Gruppe der Ebene 2 auch ihre eigenen Untergruppen als "Geschwister"
       einsammeln und sofort wieder zuklappen. */
    var panel = group.closest('.cascade-menu__panel');
    if (panel) {
      panel.querySelectorAll(':scope > li > details.cascade-menu__group[open]').forEach(function (other) {
        if (other !== group) {
          other.open = false;
          var summary = other.querySelector(':scope > summary');
          if (summary) summary.setAttribute('aria-expanded', 'false');
          /* Mit dem Geschwister auch dessen eigene Unterebenen zuklappen, sonst
             stuende beim naechsten Oeffnen noch der alte Pfad aufgeklappt da. */
          closeGroupsIn(other);
        }
      });
    }
    if (!group.open) {
      group.open = true;
      var own = group.querySelector(':scope > summary');
      if (own) own.setAttribute('aria-expanded', 'true');
    }
    positionPanel(group);
  }

  /* ---------- Hover ---------- */

  document.addEventListener('mouseover', function (event) {
    if (!hoverEnabled()) return;
    var target = event.target;
    if (!target || !target.closest) return;

    var root = target.closest('header-menu');
    if (!root) return;
    var details = detailsOf(root);
    if (!details) return;

    /* Nur den Close-Timer abraeumen, der genau dieses Item betrifft. Ein
       fremder Timer bleibt stehen - dessen Item wird stattdessen unten
       sofort geschlossen. */
    if (closeTarget === root) cancelClose();

    var previous = activeRoot;

    if (previous && previous !== root) {
      // Direktwechsel: altes Panel sofort zu, neues ohne Verzoegerung auf.
      cancelClose();
      cancelOpen();
      closeRoot(previous);
      openRoot(root);
    } else if (!details.open && openTarget !== root) {
      cancelOpen();
      openTarget = root;
      openTimer = setTimeout(function () {
        openTimer = null;
        openTarget = null;
        openRoot(root);
      }, OPEN_DELAY);
    }

    var group = groupOf(target);
    if (group) {
      openGroup(group);
    } else if (target.closest('.cascade-menu__panel--level-1')) {
      // Ueber einem Eintrag ohne Unterpunkte: offenes Panel der Ebene 2 zu.
      closeGroupsIn(details);
    }
  });

  document.addEventListener('mouseout', function (event) {
    if (!hoverEnabled()) return;
    var target = event.target;
    if (!target || !target.closest) return;

    var root = target.closest('header-menu');
    if (!root) return;

    // Bewegung innerhalb desselben Menues ist kein Verlassen.
    var to = event.relatedTarget;
    if (to && root.contains(to)) return;

    // Geplantes Oeffnen verwerfen, wenn wir das Item wieder verlassen.
    if (openTarget === root) cancelOpen();

    /* Close-Delay gilt nur innerhalb desselben Items (diagonal zur zweiten
       Ebene fahren). Beim Wechsel auf ein anderes Top-Level-Item greift
       stattdessen der Direktwechsel oben. */
    cancelClose();
    closeTarget = root;
    closeTimer = setTimeout(function () {
      closeTimer = null;
      closeTarget = null;
      if (activeRoot === root) closeRoot(root);
    }, CLOSE_DELAY);
  });

  /* ---------- Klick auf den Aufklapper ---------- */

  /* Auf Hover-Geraeten hat der Hover das Panel beim Klick laengst geoeffnet.
     Der native <details>-Toggle wuerde es dann ausgerechnet durch den Klick
     wieder schliessen. Also: Klick oeffnet, statt umzuschalten. Ohne Hover
     (Touch) bleibt das native Umschalten erhalten. */
  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || !target.closest) return;
    // Gilt fuer beide Ebenen: Chevron der Hauptnavigation und der Gruppen.
    var summary = target.closest('details.cascade-menu > summary, details.cascade-menu__group > summary');
    if (!summary) return;
    var details = summary.parentElement;
    if (hoverEnabled() && details.open) {
      event.preventDefault();
      if (details.classList.contains('cascade-menu__group')) positionPanel(details);
    }
  });

  /* ---------- Tastatur ---------- */

  function focusableLinks(panel) {
    if (!panel) return [];
    return Array.prototype.slice.call(panel.querySelectorAll(':scope > li > a, :scope > li > details > summary'));
  }

  document.addEventListener('keydown', function (event) {
    var target = event.target;
    if (!target || !target.closest) return;

    var root = target.closest('header-menu');
    if (!root) return;
    var details = detailsOf(root);
    if (!details || !details.querySelector('.cascade-menu__content')) return;

    var group = groupOf(target);
    /* Ausloeser der naechsten Ebene: der Chevron-<summary> und - bei Gruppen mit
       eigenem Linkziel - auch der Textlink daneben. Beide sind direkte Kinder
       des <li>, zu dem groupOf() aufloest; ein Blattlink im Panel darunter
       erfuellt keine der beiden Bedingungen. Genau deshalb darf die Pruefung
       nicht mehr an "steckt in einem Unterpanel" haengen - ab Ebene 2 steht
       der Ausloeser einer Gruppe selbst in einem Unterpanel. */
    var isGroupTrigger =
      group &&
      (target === triggerOf(group) ||
        (target.classList && target.classList.contains('cascade-menu__link--group')));

    switch (event.key) {
      case 'Escape': {
        // Erst die Ebene 2, dann das ganze Menue - schrittweise zurueck.
        if (group && group.open) {
          group.open = false;
          var groupSummary = triggerOf(group);
          if (groupSummary) {
            groupSummary.setAttribute('aria-expanded', 'false');
            groupSummary.focus();
          }
        } else if (details.open) {
          closeRoot(root);
          var top = details.querySelector(':scope > summary');
          if (top) top.focus();
        }
        event.preventDefault();
        break;
      }

      case 'ArrowRight': {
        if (isGroupTrigger) {
          openGroup(group);
          var first = focusableLinks(group.querySelector(':scope > ' + SUB_PANEL))[0];
          if (first) first.focus();
          event.preventDefault();
        }
        break;
      }

      case 'ArrowLeft': {
        /* Eine Ebene zurueck heisst: das Panel schliessen, IN dem der Fokus
           steht - nicht die eigene Gruppe des fokussierten Elements. Der
           Unterschied faellt erst mit der dritten Ebene auf: steht der Fokus
           auf einer Gruppe, die selbst wieder Gruppen enthaelt, zeigt
           groupOf() auf deren eigenes (noch zugeklapptes) <details>, und
           ArrowLeft tat schlicht nichts. Ueber das Panel gefunden, ist es
           immer der Aufklapper eine Ebene hoeher - fuer die bestehenden
           zweistufigen Faelle exakt derselbe wie vorher. */
        var focusedPanel = target.closest(SUB_PANEL);
        var owner = focusedPanel ? focusedPanel.parentElement : null;
        if (owner && owner.open) {
          owner.open = false;
          closeGroupsIn(owner);
          var back = triggerOf(owner);
          if (back) {
            back.setAttribute('aria-expanded', 'false');
            back.focus();
          }
          event.preventDefault();
        }
        break;
      }

      case 'ArrowDown':
      case 'ArrowUp': {
        var panel = target.closest('.cascade-menu__panel');
        if (!panel) break;
        var items = focusableLinks(panel);
        var index = items.indexOf(target);
        if (index === -1) break;
        var next = event.key === 'ArrowDown' ? index + 1 : index - 1;
        if (next < 0) next = items.length - 1;
        if (next >= items.length) next = 0;
        items[next].focus();
        event.preventDefault();
        break;
      }
    }
  });

  /* Fokus wandert auf ein anderes Top-Level-Item (Tab) -> altes Panel sofort
     zu, ohne Close-Delay. Gleiche Regel wie beim Hover-Wechsel. */
  document.addEventListener('focusin', function (event) {
    var target = event.target;
    if (!target || !target.closest) return;
    var root = target.closest('header-menu');
    if (!root) return;
    if (activeRoot && activeRoot !== root) {
      cancelClose();
      closeRoot(activeRoot);
    }
  });

  /* Fokus verlaesst das Menue komplett -> zumachen. Dawns HeaderMenu macht das
     fuer die erste Ebene bereits; hier zusaetzlich die Gruppen aufraeumen. */
  document.addEventListener('focusout', function (event) {
    var root = event.target.closest ? event.target.closest('header-menu') : null;
    if (!root) return;
    setTimeout(function () {
      if (!root.contains(document.activeElement)) closeRoot(root);
    });
  });

  /* Sicherheitsnetz und State-Abgleich: greift auch, wenn ein Panel per Klick
     oder Enter/Space geoeffnet wurde, also ganz ohne die Hover-Pfade oben.
     toggle blubbert nicht, wird in der Capture-Phase aber zugestellt. */
  document.addEventListener(
    'toggle',
    function (event) {
      var details = event.target;
      if (!details.classList || !details.classList.contains('cascade-menu')) return;
      var root = details.parentElement;
      if (details.open) {
        if (activeRoot && activeRoot !== root) closeRoot(activeRoot);
        activeRoot = root;
      } else if (activeRoot === root) {
        activeRoot = null;
      }
    },
    true
  );
})();
